import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Image from 'components/Image';

const ThemedImage = ({ image, lightImage, darkImage, ...props }) => {
  const osPrefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = useSelector(state => state.config.theme);
  const prefersDarkMode = theme === 'dark' || (theme === 'system' && osPrefersDark);

  let imagePath = image;

  if (prefersDarkMode && darkImage) {
    imagePath = darkImage;
  }
  if (!prefersDarkMode && lightImage) {
    imagePath = lightImage;
  }

  return <Image {...props} image={imagePath} />;
};

ThemedImage.propTypes = {
  image: PropTypes.string.isRequired,
  lightImage: PropTypes.string,
  darkImage: PropTypes.string,
};

ThemedImage.defaultProps = {
  lightImage: null,
  darkImage: null,
};

export default ThemedImage;
